(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cl-four-faces"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cl-four-faces')) {
    class ClFourFaces extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;
        this.variants = JSON.parse(this.querySelector('[data-cl4-variants]').textContent);
        this.querySelector('[data-cl4-details-guide]')?.addEventListener('click', () => this.querySelector('[data-cl4-guide-open]').click());
        this.formattedPrices = JSON.parse(this.querySelector('[data-cl4-formatted-prices]').textContent);
        this.rememberedTypes = new Map();
        this.variantInput = this.querySelector('[data-cl4-variant]');
        this.selected = this.variants.find(variant => String(variant.id) === this.variantInput.value);
        if (!this.selected) return;
        this.numberFormat = new Intl.NumberFormat(this.dataset.locale || 'en', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        this.wholeNumberFormat = new Intl.NumberFormat(this.dataset.locale || 'en', { maximumFractionDigits: 0 });
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        this.addEventListener('click', event => this.onClick(event), options);
        this.addEventListener('keydown', event => this.onKeydown(event), options);
        this.querySelector('form').addEventListener('submit', event => {
          if (!this.selected?.available || String(this.selected.id) !== this.variantInput.value) {
            event.preventDefault();
            this.render();
            return;
          }
          this.querySelector('[data-cl4-add]').disabled = true;
          this.querySelector('[data-cl4-add]').setAttribute('aria-busy', 'true');
          this.querySelector('[data-cl4-add-label]').textContent = this.dataset.addingLabel;
        }, options);
        document.addEventListener('click', event => { if (!this.contains(event.target)) this.closePickers(); }, options);
        window.addEventListener('pageshow', () => this.render(), options);
        window.addEventListener('popstate', () => {
          const id = new URL(window.location.href).searchParams.get('variant');
          const variant = this.variants.find(item => String(item.id) === id);
          if (variant) { this.selected = variant; this.render(); }
        }, options);
        this.querySelectorAll('[data-cl4-picker]').forEach(picker => {
          picker.addEventListener('toggle', () => { if (picker.open) this.closePickers(picker); }, options);
        });
        this.render();
        this.querySelector('[data-cl4-native]').hidden = true;
        this.querySelector('[data-cl4-pickers]').hidden = false;
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.abortController = null;
      }

      money(amount) { return `${(amount % 100 === 0 ? this.wholeNumberFormat : this.numberFormat).format(amount / 100)} ${this.dataset.currency}`; }

      getType(variant = this.selected) { return variant.option3 || 'Classic Print'; }

      typeVariants(type = this.getType()) { return this.variants.filter(variant => this.getType(variant) === type); }

      noFrameValue(type = this.getType(), size = null) {
        const variants = this.typeVariants(type).filter(variant => !size || variant.option1 === size);
        return variants.find(variant => variant.option2 === 'No frame')?.option2 || 'No frame';
      }

      noFrameLabel() { return 'No frame'; }

      isNoFrame(value, type = this.getType(), size = null) { return value === this.noFrameValue(type, size); }

      frameDisplayPrice(variant, printPrice, type = this.getType()) { return this.isNoFrame(variant.option2, type, variant.option1) ? 0 : variant.price - printPrice; }

      printVariant(size, type = this.getType()) { return this.typeVariants(type).find(variant => variant.option1 === size && variant.option2 === this.noFrameValue(type, size)); }

      printPrice(size, type = this.getType()) {
        const print = this.printVariant(size, type);
        const fallback = this.typeVariants(type).find(variant => variant.option1 === size);
        return print ? print.price : fallback ? fallback.price : null;
      }

      switchType(type) {
        if (type === this.getType()) return;
        this.rememberedTypes.set(this.getType(), this.selected);
        const variants = this.typeVariants(type);
        const remembered = this.rememberedTypes.get(type);
        const size = variants.some(variant => variant.option1 === this.selected.option1) ? this.selected.option1 : variants.find(variant => variant.available)?.option1;
        const colour = this.selected.option2.replace(' (Canvas Frame)', '');
        const frame = this.isNoFrame(this.selected.option2, this.getType(), this.selected.option1) ? this.noFrameValue(type, size) : colour !== 'No frame' && type === 'Premium Canvas' ? `${colour} (Canvas Frame)` : colour;
        const matched = variants.find(variant => variant.option1 === size && variant.option2 === frame && variant.available);
        const unframed = this.printVariant(size, type);
        const variant = remembered?.available ? remembered : matched || (unframed?.available ? unframed : variants.find(item => item.option1 === size && item.available));
        this.closePickers();
        this.choose(variant);
      }

      closePickers(except) {
        this.querySelectorAll('[data-cl4-picker]').forEach(picker => { if (picker !== except) picker.open = false; });
      }

      onClick(event) {
        const sizeButton = event.target.closest('[data-cl4-size]');
        const frameButton = event.target.closest('[data-cl4-frame]');
        const typeButton = event.target.closest('[data-cl4-type]');
        if (typeButton && !typeButton.disabled) {
          this.switchType(typeButton.dataset.cl4Type);
        } else if (sizeButton && !sizeButton.disabled && !sizeButton.hidden) {
          const size = sizeButton.dataset.cl4Size;
          const variant = this.typeVariants().find(item => item.option1 === size && item.option2 === this.selected.option2 && item.available)
            || this.printVariant(size)
            || this.typeVariants().find(item => item.option1 === size && item.available);
          this.choose(variant, sizeButton.closest('details'));
        } else if (frameButton && !frameButton.disabled && !frameButton.hidden) {
          const variant = this.typeVariants().find(item => item.option1 === this.selected.option1 && item.option2 === frameButton.dataset.cl4Frame);
          this.choose(variant, frameButton.closest('details'));
        }
        const guide = this.querySelector('[data-cl4-guide]');
        if (event.target.closest('[data-cl4-guide-open]')) { this.closePickers(); guide.showModal(); }
        if (event.target.closest('[data-cl4-guide-close]')) guide.close();
        if (event.target === guide) {
          const rect = guide.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) guide.close();
        }
      }

      choose(variant, picker) {
        if (!variant) return;
        this.selected = variant;
        this.render();
        if (picker) {
          picker.open = false;
          picker.querySelector('summary').focus({ preventScroll: true });
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', String(variant.id));
        window.history.replaceState(window.history.state, '', url);
      }

      onKeydown(event) {
        const picker = event.target.closest('[data-cl4-picker]');
        if (!picker) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          picker.open = false;
          picker.querySelector('summary').focus();
        }
        if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        picker.open = true;
        const buttons = Array.from(picker.querySelectorAll('.cl4-option:not(:disabled):not([hidden])'));
        if (!buttons.length) return;
        const index = buttons.indexOf(document.activeElement);
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : event.key === 'ArrowDown' ? (index + 1) % buttons.length : index < 0 ? buttons.length - 1 : (index - 1 + buttons.length) % buttons.length;
        buttons[next].focus();
      }

      render() {
        const variant = this.selected;
        const type = this.getType();
        const typeVariants = this.typeVariants();
        const printPrice = this.printPrice(variant.option1);
        this.variantInput.value = String(variant.id);
        this.querySelector('[data-cl4-heading-price]').textContent = this.formattedPrices[String(variant.id)];
        this.querySelectorAll('[data-cl4-type]').forEach(button => {
          button.setAttribute('aria-pressed', String(button.dataset.cl4Type === type));
          button.disabled = !this.typeVariants(button.dataset.cl4Type).some(item => item.available);
        });
        this.querySelector('[data-cl4-size-label]').textContent = variant.option1;
        const selectedFrame = this.querySelectorAll('[data-cl4-frame]');
        const frameButton = Array.from(selectedFrame).find(button => button.dataset.cl4Frame === variant.option2);
        this.querySelector('[data-cl4-frame-label]').textContent = this.isNoFrame(variant.option2, type, variant.option1) ? this.noFrameLabel(type) : frameButton?.querySelector('.cl4-frame-name').textContent.trim() || variant.option2;
        this.querySelector('[data-cl4-print-price]').textContent = this.money(printPrice);
        this.querySelector('[data-cl4-frame-price]').textContent = this.money(this.frameDisplayPrice(variant, printPrice, type));
        this.querySelector('[data-cl4-total]').textContent = this.money(variant.price);
        this.querySelector('[data-cl4-picker="size"] > summary').setAttribute('aria-label', `${this.dataset.sizeLabel}: ${variant.option1}, ${this.money(printPrice)}`);
        this.querySelector('[data-cl4-picker="frame"] > summary').setAttribute('aria-label', `${this.dataset.frameLabel}: ${this.querySelector('[data-cl4-frame-label]').textContent}, ${this.money(this.frameDisplayPrice(variant, printPrice, type))}`);
        this.querySelectorAll('[data-cl4-size]').forEach(button => {
          const matching = typeVariants.filter(item => item.option1 === button.dataset.cl4Size);
          button.hidden = matching.length === 0;
          button.disabled = !matching.some(item => item.available);
          button.setAttribute('aria-pressed', String(button.dataset.cl4Size === variant.option1));
          button.querySelector('.cl4-money').textContent = matching.length ? this.money(this.printPrice(button.dataset.cl4Size)) : this.dataset.unavailable;
        });
        selectedFrame.forEach(button => {
          const match = typeVariants.find(item => item.option1 === variant.option1 && item.option2 === button.dataset.cl4Frame);
          button.hidden = !match;
          button.disabled = !match?.available;
          button.setAttribute('aria-pressed', String(button.dataset.cl4Frame === variant.option2));
          button.querySelector('[data-cl4-option-price]').textContent = match ? this.money(this.frameDisplayPrice(match, printPrice, type)) : this.dataset.unavailable;
        });
        this.querySelectorAll('[data-cl4-guide-size]').forEach(row => {
          row.hidden = !typeVariants.some(item => item.option1 === row.dataset.cl4GuideSize);
        });
        const submit = this.querySelector('[data-cl4-add]');
        submit.disabled = !variant.available;
        submit.removeAttribute('aria-busy');
        this.querySelector('[data-cl4-add-label]').textContent = variant.available ? this.dataset.addLabel : this.dataset.soldOut;
        this.querySelector('[data-cl4-status]').textContent = `${type}, ${variant.option1}, ${variant.option2}, ${this.money(variant.price)}${variant.available ? '' : ', ' + this.dataset.soldOut}`;
      }
    }
    customElements.define('cl-four-faces', ClFourFaces);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cl-gallery-foundation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cl-gallery-rail')) {
    customElements.define('cl-gallery-rail', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-clg-track]');
        this.prev = this.querySelector('[data-clg-prev]');
        this.next = this.querySelector('[data-clg-next]');
        if (!this.track || !this.prev || !this.next) return;
        this.abort?.abort();
        this.abort = new AbortController();
        const opts = { signal: this.abort.signal };
        this.update = () => {
          const max = this.track.scrollWidth - this.track.clientWidth;
          this.prev.disabled = this.track.scrollLeft <= 2;
          this.next.disabled = this.track.scrollLeft >= max - 2;
        };
        const move = direction => {
          const item = this.track.firstElementChild;
          if (!item) return;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const width = item.getBoundingClientRect().width + gap;
          const count = Math.max(1, Math.round(this.track.clientWidth / width));
          this.track.scrollBy({left:direction*width*count,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
        };
        this.prev.addEventListener('click',()=>move(-1),opts);
        this.next.addEventListener('click',()=>move(1),opts);
        this.track.addEventListener('scroll',this.update,{...opts,passive:true});
        this.resize?.disconnect();
        this.resize = new ResizeObserver(this.update);
        this.resize.observe(this.track);
        this.update();
      }
      disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
